<template>
    <div class="container-fluid" v-if="school">
        <div class="row justify-content-between">
            <div class="col">
                <h3>{{school.name}}</h3>
                <h3>Багш нарын хоцролтын мэдээлэл</h3>
            </div>

        
        </div>
        <div class="card shadow my-4">
            <div class="card-header py-3">
                <div class="row">
                    <div class="col">
                        <h6 class="m-0 font-weight-bold text-primary">Багш нарын жагсаалт</h6>
                    </div>
                    <div class="col-auto">
                        <i class="fas fa-grip-horizontal text-danger" style="font-size:20px;" v-if="showSimple" @click="showSimple=!showSimple"></i>
                        <i class="fas fa-grip-lines text-danger" style="font-size:20px;" v-else @click="showSimple=!showSimple"></i>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12 my-3">
                        <div class="btn-group" role="group" >
                            <button type="button" class="btn btn-sm btn-outline-success" @click="searchField='email'" v-bind:class="{ 'btn btn-success text-white': searchField!=null && searchField=='email' }">Имэйл</button>
                            <button type="button" class="btn btn-sm btn-outline-success" @click="searchField='code'" v-bind:class="{ 'btn btn-success text-white': searchField!=null && searchField=='code' }">Код</button>
                            <button type="button" class="btn btn-sm btn-outline-success" @click="searchField='name'" v-bind:class="{ 'btn btn-success text-white': searchField!=null && searchField=='name' }">Нэр</button>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group" >
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Та хайх талбараа сонгоод хайх утгаа оруулаад хайх товч дээр дарна уу"
                                v-model="searchValue"
                                v-on:keyup.enter="search(searchValue)"
                            />
                        </div>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-success btn-block" @click="search(searchValue)"><i class="mr-2 fas fa-search"></i>Хайх</button>
                    </div>
                </div>
                <div class="mb-3" v-if="searched && searchValue!=null && searchValue!=''">
                    <h4>
                        <div class="badge badge-pill badge-info">
                            {{searchValue}}
                            <i @click="searchValue=null;searched=false;_getData()" class="fas fa-times ml-2" style="cursor:pointer"></i>
                        </div>
                    </h4>
                </div>
                <div class="table-responsive" v-if="teachers!=null && teachers.length>0">
                <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                    <tr>
                        <th>№</th>
                        <th>Овог/Нэр</th>
                        <th>Багшийн код</th>
                        <th>Имэйл</th>
                        <th>Үзүүлэлт</th>
                        <th v-if="!showSimple">Төлөв</th>
                        <th>Үйлдэл</th>
                    </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(teacher, index) in teachers" v-bind:key="teacher.id">
                            <td>{{index+1}}</td>
                            <td>{{teacher.lastname}} / {{teacher.name}}</td>

                            <td>{{teacher.code}}</td>
               
                            <td>{{teacher.email}}</td>
                            <td>
                                <ul>    
                                    <li v-for="lsdata in teacher.lessons">
                                        <div style="cursor: pointer" class="text-primary" @click="$router.push({name:'ILessonLog', params: {schoolId:schoolId, lessonId: lsdata.id}   })">
                                            <span v-if="lsdata.lessonInfo">
                                                / {{lsdata.lessonInfo.name}}
                                                <span v-if="lsdata.lessonInfo && lsdata.lessonInfo.classNos && lsdata.lessonInfo.classNos.length>0 "> - {{lsdata.lessonInfo.classNos[0]}}</span>
                                                /
                                            </span>
                                            -
                                            <span v-if="lsdata">{{lsdata.hozorson}} минут</span>
                                        </div>
                                    </li>
                                    <li class="text-danger" v-if="teacher.hozorson">Нийт - {{teacher.hozorson}}</li>
                                </ul>
                            </td>
                            <td v-if="!showSimple">
                                <span v-if="teacher.googleUser==null || teacher.googleUser==undefined" class="badge notinsystem">Системд холбогдоогүй</span>
                                <span v-else class="badge badge-success">Системд холбогдсон</span>
                            </td>
                            <td>
                                
                                <button class="btn btn-warning btn-sm" @click="_edit(teacher)">засах</button>
                            </td>
                        </tr>
                    
                    </tbody>
                </table>
                    <div v-if="!searched">
                        <button v-if="loading==false" @click="getTeacherData()" class="nextbutton shadow" style=""><i class="fas fa-arrow-down fa-2x" style="color:black!important;height:40; width:40"></i></button>
                        <button v-else type="button" class="btn btn-success btn-block" disabled>
                            <span class="spinner-border spinner-border-sm"></span>
                            Loading..
                        </button>
                    </div>
                </div>
                <div v-else class="alert alert-info text-center">Одоогоор багшийн мэдээлэл ороогүй байна.</div>
            </div>
        </div>

    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    const fb = require('../../../firebaseConfig.js')

    export default {
        data() {
            return {
               teachers:[],
               lastVisible:null,
               loading:false,
               last:false,
               showSimple:true,
               searchValue:null,
               searched:false,
               searchField:'email',
               pageSize:20,
               school:null
            }
        },
        props: {
            schoolId: { 
                required: true,
            },
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        methods: {

            async _getData(){
                var schoolDoc=await fb.db.doc('schools/'+this.schoolId).get();
                if(schoolDoc.exists){
                    let school=schoolDoc.data();
                    school.id=schoolDoc.id;
                    school.ref=schoolDoc.ref;
                    this.school=school
                    this.teachers=[];
                
                    this.getTeacherData();
                }

                
            },
    
            async getTeacherData(){

                if(this.last==false){
                    this.loading=true;
                    var query;
                    if(this.lastVisible==null)
                    
                        query=fb.db.collection("schools/"+this.schoolId+"/teachers").orderBy("name", "asc");
                    
                    else
                        query=fb.db.collection("schools/"+this.schoolId+"/teachers").orderBy("name", "asc").startAfter(this.lastVisible);

                    
                    query=query.limit(400);
                    if(query!=null){
                        var documentSnapshots=await query.get();
                        this.lastVisible= documentSnapshots.docs[documentSnapshots.docs.length-1];
                        documentSnapshots.forEach(doc=> {
                            let object=doc.data()
                            object.id = doc.id;
                            object.lessons=[];
                            doc.ref.collection("teacher_lessons").get().then(lsDocs=>{
                                lsDocs.forEach(lsValue=>{
                                    if(lsValue.exists){
                                        let lsdata=lsValue.data();
                                        lsdata.id=lsValue.id;
                                        lsdata.lessonInfo=null;
                                        if(lsdata.lesson){
                                            lsdata.lesson.get().then(lessonDoc=>{
                                                let lesson= lessonDoc.data();
                                                lesson.id=lessonDoc.id;
                                                lesson.path=lessonDoc.path;
                                                lsdata.lessonInfo=lesson;
                                            });
                                        }
                                            object.lessons.push(lsdata);

                                    }
                                });
                            });
                            if(object.hide!=true)
                                this.teachers.push(object);
                        });
                        if(documentSnapshots.size!=400)
                            this.last=true;
                    }
                    this.loading=false;
                }
               
            },
            _edit(teacher){
                this.$router.push({ name: 'TeacherAdd', params: { teacherId: teacher.id} })
            },
            search(value){
                if(value!=null && value!='' && this.searchField!=null && this.searchField!=''){
                    this.lastVisible=null;
                    this.last=false;
                    this.searched=true;
                    this.teachers=[];
                    this.searchBy(value);
                }
                
            },
            async searchBy(value){
                if(this.searchField=="code")
                    value=value.toLowerCase();
                    this.loading=true;
                    var query;
                    query=fb.db.collection("schools/"+this.schoolId+"/teachers").where(this.searchField, "==", value);
                    // if(this.schools!=null){
                    //     query=query.where('school', "in", this.schools)
                    // }

                    if(query!=null){
                        var documentSnapshots=await query.get();
                        documentSnapshots.forEach(doc=> {
                            let object=doc.data();
                            object.id = doc.id;
                            this.teachers.push(object);
                        });

                    }
                    this.loading=false;

            },

  
        },
        created() {
            this.teachers=[];
            this._getData();
                
        },

        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
